// src/pages/Vehicles.js
import React from 'react';

const Vehicles = () => {
  return <div><h2>Our Vehicles</h2></div>;
};

export default Vehicles;
